import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Chip from 'Chip';

/**
 * for this page
 */
import CustomStocks from './customStocks';
import LeftNav from './leftNav';

class LeftCon extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.leftCon}>
                <CustomStocks />
                <Chip id="170090" type="struct" title="左侧导航" groupName="财经行情中心" content={content}>
                    <LeftNav content={content} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(LeftCon);
